export class Constants {
    public static INT_SAML = "SAML";
    public static INT_OIDC = "OIDC";

    public static REST_GET_USER = "user";

    public static ROLE_ADMIN = "admin";
	public static ROLE_USER = "user";

    public static P_EMAIL = "(?!.{50})^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,6}$";
    public static P_PASSWORD = "";
    public static P_NAME = "^[a-zA-Z]{2,40}$";
    public static P_CLUSTER = "^[a-zA-Z]{2,40}$";
    public static P_MINISTRY = "^[a-zA-Z]{2,40}$";
    public static P_PASSCODE = "^[a-zA-Z0-9]{4}$";
    public static P_NUMBERS_ONLY = "^-?([0-9]*)?$";
    public static EF_NAME = "^[A-Za-zÀ-ÿ0-9]+(?:[' -][A-Za-zÀ-ÿ0-9]+)*$";
    public static EF_PASSWORD = "[a-zA-ZÀ-ÿ0-9 !\"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]*";
    
    //public static EF_EMAIL = "(?!.{50})^[A-Za-z0-9._%+-]+@[A-Za-z0-9_.-]+\\.[A-Za-z]{1,6}$";
    //public static EF_EMAIL = "(?!.{50})^[A-Za-z0-9._%+-]+@[A-Za-z0-9_.-]+\\.[A-Za-z_-]{1,}$";
    //public static EF_EMAIL = "^[A-Za-z0-9]+([._-]?[A-Za-z0-9]+)*@[A-Za-z0-9]+([.-_]?[A-Za-z0-9]+)*\.[A-Za-z_-]{1,}$";
    //public static EF_EMAIL = "^[A-Za-zÀ-ÿ0-9]+([._-]?[A-Za-zÀ-ÿ0-9]+)*@[A-Za-zÀ-ÿ0-9]+([.-_]?[A-Za-zÀ-ÿ0-9]+)*\.[A-Za-zÀ-ÿ_-]{1,}$";
    //public static EF_EMAIL = "^[A-Za-zÀ-ÿ0-9]+([!#$%&'*+/=?^_`{|}~.-]?[A-Za-zÀ-ÿ0-9]+)*@[A-Za-zÀ-ÿ0-9]+([.-_]?[A-Za-zÀ-ÿ0-9]+)*\.[A-Za-zÀ-ÿ_-]{1,}$";
    //PR-1223
    //public static EF_EMAIL = "(?!.{50})^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\-\\.[A-Za-z]{1,6}$";
    //PR-1226
    public static EF_EMAIL = /^[a-zA-ZÀ-ÿ0-9_%+!#$%&'*+/=?^_`{|}~-]([a-zA-ZÀ-ÿ0-9._%+!#$%&'*+/=?^_`{|}~-]*[a-zA-ZÀ-ÿ0-9_%+!#$%&'*+/=?^_`{|}~-])?@(?!\.|-)[a-zA-ZÀ-ÿ0-9.-]+\.[a-zA-ZÀ-ÿ0-9]{2,}$/;
    
    public static SEARCH_NAME = "^[A-Za-zÀ-ÿ0-9'\*]+(?:[' -][A-Za-zÀ-ÿ0-9']+)*$";
    public static SEARCH_GUID = "^[\da-fA-F]{8}-([\da-fA-F]{4}-){3}[\da-fA-F]{12}$";
    public static SEARCH_EMAIL_OLD = /^[a-zA-ZÀ-ÿ0-9_%+!#$%&'*+/=?^_`{|}~-]([a-zA-ZÀ-ÿ0-9._%+!#$%&'*+/=?^_`{|}~-]*[a-zA-ZÀ-ÿ0-9_%+!#$%&'*+/=?^_`{|}~-])?@(?!\.|-)[a-zA-ZÀ-ÿ0-9.-]+\.[a-zA-ZÀ-ÿ0-9]{2,}$/;

    // working
    //public static SEARCH_EMAIL = "^[A-Za-zÀ-ÿ0-9._\*]+(?:[@][A-Za-zÀ-ÿ._*-0-9]+)*$";
    // Verify
    public static SEARCH_EMAIL = "^[a-zA-ZÀ-ÿ0-9_%+!#$%&'*+/=?^`{|}~-]+([a-zA-ZÀ-ÿ0-9._%+!#$%&'*+/=?^_`{|}~-])*(?:[@][A-Za-zÀ-ÿ._*-0-9]+)*$";
    public static SEARCH_ASTERISK = /^(?:[a-zA-ZÀ-ÿ0-9'@._-]*\*[a-zA-ZÀ-ÿ0-9'@._-]*)*$/;

    public static SEARCH_RESULTS_MAX_ALLOWED = 500;
    public static SEARCH_RESULTS_PER_PAGE = 25;
    public static SESSION_KEY_USER = "BPS_USER";

    public static VALID_PREF_LANG = ['en', 'fr'];

    public static DEFAULT_OTP = "00000000";
    public static BPS_MPR_ADMIN = "BPS_MPR_ADMIN";
}